<template>
    <div>
    <div class="popup__header">
        <div class="title">Взять отгул</div>
    </div>


    <div class="popup__content">
        <div class="">
            <calendar
                    @update="form.selectedDay.error = false;"
                v-model="form.selectedDay.value">
            </calendar>
        </div>
        <div class="mb40 mt40">
            <input-styled v-model="form.text.value"
                              :placeholder="'Укажите причину отгула, например «Беру отпуск» или «По личным делам»'"
                              :isError="form.text.error"
                              :errorText="form.text.errorText"
                              :class="'inp-placeholder-showed'"
                              @focus="removeError(form.text)"
                              @input="removeError(form.text)"></input-styled>
        </div>
        <div class="mt40">
            <input @change="removeError(form.checkbox)" v-model="form.checkbox.value"  :class="{error:form.checkbox.error, 'repeat-error': form.checkbox.repeatError}" type="checkbox" id="checkbox">
            <label for="checkbox">Я подтверждаю, что заранее предупредил команду о датах отгулов и получил согласие руководства</label>
        </div>
        <div class="df  mt40">
            <submit-btn @click="send" tag="button" :type="btnType">
                Подтвердить
            </submit-btn>
            <div class="text-color-red ml24 df" v-if="form.selectedDay.error"><span class="i i-info3 i--red mr4"></span>Выберите даты отгулов</div>
        </div>
    </div>
</div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    import Calendar from '@/components/Calendar.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputStyled from '@/components/forms/InputStyled.vue';
    import {mapState} from "vuex";

    export default {
        name: "TakeDayOff",
        components: {
            Tooltip,
            Calendar,
            SubmitBtn,
            InputStyled
        },
        props: {

        },
        watch: {

        },
        data: function () {
            return {
                btnType: 'normal',
                form: {
                    selectedDay: {
                        value: '',
                        error: false,
                        repeatError: false,
                    },
                    text: {
                        value: '',
                        error: false,
                        repeatError: false,
                    },
                    checkbox: {
                        value: false,
                        error: false,
                        repeatError: false,
                    },
                },
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                options: state => state.options,
            }),
        },
        mounted: function () {

        },
        emits: ['update:modelValue', 'calendarshow'],
        methods: {
            send(){
                let error = false;
                for(let field in this.form){
                    let errorField = false;
                    this.form[field].error = false;

                    if(field == 'text' && this.form[field].value.length == 0){
                        errorField = true;
                    }

                    if(field == 'selectedDay' && !this.form[field].value.start){
                        errorField = true;
                    }

                    if(field == 'checkbox' && this.form[field].value == false){
                        errorField = true;
                    }

                    if(errorField){
                        error = true;
                        setTimeout(() => {
                            this.form[field].error = true;
                        });
                    }
                }

                if(!error) {
                    this.btnType = 'load';
                    let params = [];
                    for(let field in this.form) {
                        if(field == 'selectedDay'){
                            params[field+'Start'] = this.form[field].value.start;
                            params[field+'End'] = this.form[field].value.end;
                        } else {
                            params[field] = this.form[field].value;
                        }

                    }
                    this.$store.dispatch('workers/takeHoliday',params).then(() => {
                        this.btnType = 'ok';
                        setTimeout(()=>{
                            this.$store.commit('popups/close', {name: this.popups.takeDayOff.name});
                        }, this.options.delayPopupClose);
                    },()=>{});
                }
            },
            removeError(form) {
                form.error = false;
            },
        },
    }
</script>

<style scoped>
</style>
